"use client";

import { useEffect, useState } from "react";

// Faux-incrementing counter per MIGRATION.md §4 #2: client-only, base 12,847,
// +1 per 8–12s. No backend call. Hydration-safe: same initial value SSR + CSR.
const BASE_COUNT = 12_847;
const MIN_INTERVAL_MS = 8_000;
const MAX_INTERVAL_MS = 12_000;

export default function LiveCounter() {
  const [count, setCount] = useState(BASE_COUNT);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      const delay =
        MIN_INTERVAL_MS +
        Math.random() * (MAX_INTERVAL_MS - MIN_INTERVAL_MS);
      timer = setTimeout(() => {
        setCount((c) => c + 1);
        schedule();
      }, delay);
    };
    schedule();
    return () => clearTimeout(timer);
  }, []);

  return (
    <span className="inline-flex items-center gap-2 rounded-full bg-ink-50 px-3 py-1.5 text-xs font-semibold text-ink-700">
      <span
        aria-hidden="true"
        className="pulse-dot inline-block h-2 w-2 rounded-full bg-sig-green"
      />
      <span className="tabular">
        {count.toLocaleString("en-US")}
      </span>
      <span className="text-ink-500">replies sent</span>
    </span>
  );
}
